import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    VenueStatus:false,
    AssignVenueStatus:false,
    VenueRoomStatus:false,
    VenueRoomUpdateStatus:false,
    AddVenueStatus:false,
    EditVenueStatus:false,
    AddContactVenueStatus:false,
    limit: null,
};

 const venueSlice = createSlice({
  name: "venue",
  initialState,
  reducers: {
    deleteVenueStatus: (state, action) => {
        state.VenueStatus = action.payload;
      },
      assignedDeleteVenueStatus: (state, action) => {
        state.AssignVenueStatus = action.payload;
      },
    venueRoomStatus: (state, action) => {
        state.VenueRoomStatus = action.payload;
      },
      venueRoomUpdateStatus: (state, action) => {
        state.VenueRoomUpdateStatus = action.payload;
      },
      addVenueStatus: (state, action) => {
        state.AddVenueStatus = action.payload;
      },
      editVenueStatus: (state, action) => {
        state.EditVenueStatus = action.payload;
      },
      addContactVenueStatus: (state, action) => {
        state.AddContactVenueStatus = action.payload;
      },
      setVenueLimit: (state, action) => {
        state.limit = action.payload;
      },
  },
});

export const {deleteVenueStatus,assignedDeleteVenueStatus,venueRoomStatus,venueRoomUpdateStatus,addVenueStatus,editVenueStatus,addContactVenueStatus,setVenueLimit } = venueSlice.actions;

export default venueSlice.reducer;
